import { create } from 'zustand';

type SidebarState = {
  isDesktopSidebarOpen: boolean;
  setIsDesktopSidebarOpen: (isOpen: boolean) => void;
};

const useSidebarStore = create<SidebarState>((set) => ({
  isDesktopSidebarOpen: true,
  setIsDesktopSidebarOpen: (isOpen: boolean) => set({ isDesktopSidebarOpen: isOpen }),
}));

export default useSidebarStore;
